"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.client = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _addresses = _interopRequireDefault(require("./addresses"));
var _auth = _interopRequireDefault(require("./auth"));
var _content = _interopRequireDefault(require("./content"));
var _members = _interopRequireDefault(require("./members"));
var _partners = _interopRequireDefault(require("./partners"));
var _requests = _interopRequireDefault(require("./requests"));
var _vendors = _interopRequireDefault(require("./vendors"));
var _views = _interopRequireDefault(require("./views"));
var _interests = _interopRequireDefault(require("./interests"));
var _password = _interopRequireDefault(require("./password"));
var _secret = _interopRequireDefault(require("./members/secret"));
var _wallet = _interopRequireDefault(require("./wallet"));
var _passes = _interopRequireDefault(require("./passes"));
var instance = _axios["default"].create();
instance.defaults.withCredentials = true;
var _default = exports["default"] = instance;
var client = exports.client = {
  addresses: _addresses["default"],
  auth: _auth["default"],
  content: _content["default"],
  members: _members["default"],
  partners: _partners["default"],
  requests: _requests["default"],
  vendors: _vendors["default"],
  views: _views["default"],
  interests: _interests["default"],
  password: _password["default"],
  secret: _secret["default"],
  wallet: _wallet["default"],
  passes: _passes["default"],
  isCancel: _axios["default"].isCancel,
  get: function get(url) {
    return instance.get(url);
  }
};